<template>
    <div class="footer">
        <!-- footer -->
        <section class="bg-secondary">
            <div class="container">
                <div class="row text-center">
                    <div class="col-md-12">
                        <img src="img/logo.svg" class="logo-footer img-fluid">
                    </div>
                </div>
            </div>
        </section>
        <footer class="overflow-visible ">
            <div class="container">
                <div class="row v-align-children">
                    <div class="col-lg-12 text-center" v-if="this.$i18n.locale === 'nl'">
                        <span class="sub-sub"><router-link to="/copyright">Copyright {{ year }} LOCOmotion</router-link> | <router-link
                            :to="$t('privacy-pagina')">{{ $t('privacyverklaring') }}</router-link></span>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            'year': (new Date).getFullYear()
        }
    }
}
</script>
